import { ApiContext } from '@/chat_client/ApiChatClient'
import getCurrentBearerToken from '@/chat_client/api/authentication/getCurrentBearerToken'

export default async function getRooms({ client, config }: ApiContext) {
  const token = await getCurrentBearerToken({ client, config })

  const response = await client.rooms.list(token, { format: 'json' })
  return response
}
